import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUkFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1335_58765)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1382 41.3787H0.862594C0.386522 41.3787 0.000488281 40.9926 0.000488281 40.5166V9.48222C0.000488281 9.00615 0.386522 8.62012 0.862594 8.62012H49.1383C49.6144 8.62012 50.0004 9.00615 50.0004 9.48222V40.5166C50.0003 40.9926 49.6143 41.3787 49.1382 41.3787Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0003 9.48222C50.0003 9.00615 49.6143 8.62012 49.1382 8.62012H45.2813L29.3106 19.0837V8.62012H20.69V19.0837L4.71941 8.62012H0.862594C0.386522 8.62012 0.000488281 9.00615 0.000488281 9.48222V11.7118L13.7025 20.689H0.000488281V29.3097H13.7025L0.000488281 38.287V40.5166C0.000488281 40.9926 0.386522 41.3787 0.862594 41.3787H4.71951L20.6902 30.9151V41.3787H29.3108V30.9151L45.2815 41.3787H49.1384C49.6145 41.3787 50.0005 40.9926 50.0005 40.5166V38.287L36.2985 29.3098H50.0003V20.6891H36.2983L50.0003 11.7118V9.48222Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0003 22.4132H27.5866V8.62012H22.4142V22.4132H0.000488281V27.5856H22.4142V41.3787H27.5866V27.5856H50.0003V22.4132Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.4763 29.3096L0.0253906 40.6374C0.0864255 41.0537 0.429686 41.3786 0.862985 41.3786H2.05038L20.6431 29.3097H17.4763V29.3096Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.8279 29.3096H30.6611L49.2268 41.3607C49.6595 41.3146 50.001 40.9613 50.001 40.5164V39.8076L33.8279 29.3096Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.000976562 10.4338L15.7996 20.689H18.9664L0.503221 8.7041C0.2083 8.84111 0.000976562 9.13554 0.000976562 9.48213V10.4338Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.4783 20.689L49.9711 9.33388C49.8985 8.93135 49.5625 8.62012 49.139 8.62012H47.9039L29.3115 20.689H32.4783Z",
					fill: "#CD343C"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1335_58765",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgUkFlag);
export { ForwardRef as ReactComponent };
